import request from 'superagent';
import moment from 'moment';
import config from '../config';

const data = (query) => {
  return new Promise((resolve, reject) => {
    request
    .get(`${config.serverUrl}/flight`)
    .set('Content-Type', 'application/json')
    .query('limit=100&where=' + JSON.stringify(query))
    .end(function(err, resp) {
      if (err) {
        return reject(err);
      }

      return resolve(resp.body);
    });
  });
};

module.exports = {
  data() {
    return data();
  },

  dataWithQuery(query = {}) {
    return data(query);
  },

  dynamicStatusForFlight(flight) {
    /*
    0 = on time
    1 = departed
    2 = landed
    3 = delayed
    4 = canceled
    5 = check-in
    6 = boarding
    */
    return flight.status;
  }
};



// WEBPACK FOOTER //
// ./src/services/flight.js